"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceDetails = exports.InstanceProduct = exports.isInstanceProduct = exports.Instance = exports.isInstance = exports.isCreateInstance = exports.isInstanceState = exports.InstanceStates = exports.isPublicInstanceApiKeySecret = exports.isPublicInstanceApiKey = exports.isDiskUsage = exports.isQueryUsage = exports.isInstanceType = exports.InstanceType = void 0;
const validation_1 = require("../validator/validation");
const datelike_1 = require("../types/datelike");
const uuid_1 = require("../types/uuid");
const instanceType_1 = require("./instanceType");
Object.defineProperty(exports, "InstanceType", { enumerable: true, get: function () { return instanceType_1.InstanceType; } });
Object.defineProperty(exports, "isInstanceType", { enumerable: true, get: function () { return instanceType_1.isInstanceType; } });
const metadata_1 = require("./metadata");
const subdomain_1 = require("../types/subdomain");
const PendingSubscriptionChange_1 = require("./PendingSubscriptionChange");
const ValidatorClass_1 = require("../validator/ValidatorClass");
exports.isQueryUsage = (0, validation_1.isObjectOf)({
    atTime: datelike_1.isDateLike,
    totalCalls: validation_1.isNumber,
});
exports.isDiskUsage = (0, validation_1.isObjectOf)({
    atTime: datelike_1.isDateLike,
    environmentDataGb: validation_1.isNumber,
});
exports.isPublicInstanceApiKey = (0, validation_1.isObjectOf)({
    id: validation_1.isString,
    type: (0, validation_1.isLiteral)('READ_ONLY', 'READ_WRITE'),
});
exports.isPublicInstanceApiKeySecret = (0, validation_1.isObjectOf)({
    id: validation_1.isString,
    type: (0, validation_1.isLiteral)('READ_ONLY', 'READ_WRITE'),
    key: validation_1.isString,
});
exports.InstanceStates = [
    'CREATING',
    'READY',
    'UPDATING',
    'DISABLED',
    'DELETING',
    'DELETED',
];
exports.isInstanceState = (0, validation_1.isLiteral)(...exports.InstanceStates);
exports.isCreateInstance = (0, validation_1.isObjectOf)({
    instanceName: subdomain_1.isSubdomain,
    instanceType: instanceType_1.isInstanceType,
    extraStorage: validation_1.isNumber.or(validation_1.isUndefined),
    promotionCode: (0, validation_1.optional)(validation_1.isString),
});
exports.isInstance = (0, validation_1.isObjectOf)({
    id: uuid_1.isUUID,
    name: subdomain_1.isSubdomain,
    ownerId: uuid_1.isUUID,
    type: instanceType_1.isInstanceType,
    createdAt: datelike_1.isDateLike,
    state: exports.isInstanceState,
    metadata: (0, validation_1.optional)(metadata_1.isStripeMetadata),
});
class Instance extends (0, ValidatorClass_1.ValidatorClass)(exports.isInstance) {
}
exports.Instance = Instance;
exports.isInstanceProduct = (0, validation_1.isObjectOf)({
    id: validation_1.isString,
    active: validation_1.isBoolean,
    description: validation_1.isString,
    name: validation_1.isString,
    type: instanceType_1.isInstanceType,
    apiCallLimit: validation_1.isString,
    storage: validation_1.isString,
    activeTime: validation_1.isString,
    sleepTime: validation_1.isString,
    removedAfterInactive: validation_1.isString,
    price: validation_1.isNumber,
    tax: validation_1.isNumber,
    taxPercentage: validation_1.isNumber.which((0, validation_1.satisfiesCondition)(n => n >= 0 && n <= 100 && n === Number(n.toFixed(0)))),
    total: validation_1.isNumber,
});
class InstanceProduct extends (0, ValidatorClass_1.ValidatorClass)(exports.isInstanceProduct) {
}
exports.InstanceProduct = InstanceProduct;
exports.isInstanceDetails = (0, validation_1.isAllOf)((0, validation_1.isObjectOf)({
    id: uuid_1.isUUID,
    name: subdomain_1.isSubdomain,
    createdAt: datelike_1.isDateLike,
    ownerId: uuid_1.isUUID,
    hostname: validation_1.isString,
    ownerName: validation_1.isString,
    stripeSubscriptionId: validation_1.isString.or(validation_1.isNull),
    extraStorage: validation_1.isNumber.or(validation_1.isNull),
    queryUsage: (0, validation_1.isArrayOf)(exports.isQueryUsage),
    diskUsage: (0, validation_1.isArrayOf)(exports.isDiskUsage),
    pendingSubscriptionChange: PendingSubscriptionChange_1.isPendingSubscriptionChange.or(validation_1.isUndefined),
    state: exports.isInstanceState,
    metadata: metadata_1.isStripeMetadata.or(validation_1.isUndefined),
}), (0, validation_1.isSomeOf)((0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)(instanceType_1.InstanceType.Sandbox),
}), (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)(instanceType_1.InstanceType.Production, instanceType_1.InstanceType.Developer),
    teamId: uuid_1.isUUID,
    teamName: validation_1.isString,
})));
//# sourceMappingURL=instances.js.map